import { Component, OnDestroy } from '@angular/core';
import { MatDialog, MatDialogConfig } from "@angular/material/dialog";
import { FormService } from "../../services/form.service";
import { UntypedFormArray, UntypedFormGroup } from "@angular/forms";
import { ConsentMoversModalComponent } from "../../form-parts/consent-movers-modal/consent-movers-modal.component";
import { atLeastOneMoverSelected } from '../../services/custom-validators';

@Component( {
	selector: 'app-consent-movers',
	templateUrl: './consent-movers.component.html',
	styleUrls: ['./consent-movers.component.scss']
} )
export class ConsentMoversComponent implements OnDestroy {

	consentMovers !: UntypedFormGroup
	formGroupName : string = 'consentMovers'
	readonly maxDisplayed: number = 5
	public displayedIndices: number[] = []

	constructor( public formService: FormService, private dialog: MatDialog ) {
	}

	public ngOnInit(): void {

		this.consentMovers = this.formService.mainForm.get( this.formGroupName ) as UntypedFormGroup;

		this.formService.moversConsentUpdate$.subscribe( () => {

			this.updateDisplayedMovers();

			// Add validation after movers are updated
			const moversArray = this.allMovers;
			this.consentMovers.setValidators(atLeastOneMoverSelected());
			this.consentMovers.updateValueAndValidity();
		} );
	}

	public ngOnDestroy(): void {
	}

	public onSubmit() {
		this.consentMovers.markAllAsTouched();
		this.formService.submitFormGroup(this.consentMovers);
	}

	public updateDisplayedMovers() {

		const allMovers = this.allMovers;

		// Get all controls and sort them: selected first, then unselected
		const sortedControls = [...allMovers.controls].map((control, index) => ({ control, index }))
			.sort((a, b) => {
				const aSelected = a.control.get('checkbox')?.value;
				const bSelected = b.control.get('checkbox')?.value;
				return bSelected ? 1 : aSelected ? -1 : 0;
			});

		// Take the first 5 indices
		this.displayedIndices = sortedControls
			.slice(0, this.maxDisplayed)
			.map(({ index }) => index);
	}

	get allMovers(): UntypedFormArray {
		return this.consentMovers.get('movers') as UntypedFormArray || [];
	}

	public openModal() {
		console.log( 'Opening movers consent popup' );

        const dialogConfig = new MatDialogConfig();
		dialogConfig.height = 'calc( 100vh - 305px )';
		dialogConfig.maxHeight = '850px';
		dialogConfig.width = '940px';
		dialogConfig.backdropClass = 'modal-blurred-bg';
		dialogConfig.panelClass = ['modal-dialog','prematch-dialog'];

		// Get just the values from the movers array
		const moverValues = this.allMovers.controls.map(control => ({
			checkbox: control.get('checkbox')?.value,
			_id: control.get('_id')?.value,
			_name: control.get('_name')?.value,
			_logo: control.get('_logo')?.value,
			_rating: control.get('_rating')?.value,
			_amount: control.get('_amount')?.value,
			_city: control.get('_city')?.value
		}));

		// Pass just the values to the modal
		dialogConfig.data = { moverValues };

	    const dialogRef = this.dialog.open(ConsentMoversModalComponent, dialogConfig);

		dialogRef.afterClosed().subscribe(confirmed => {

			if( confirmed ) {
				// Update the displayed movers after modal confirmation
				this.updateDisplayedMovers();
			}
		} );
	}
}
